import logObjectFields from './logObjectFields';

function logGotQueryParams(endpoint, params, request) {
    logObjectFields(endpoint + ' queryParams', params, request.queryParams);
}

export default logGotQueryParams;